import * as actionTypes from '../types/modal';

const initialState = {
  status: 0,
  visibleModalPostStock: false,
  loadedModalPostStock: false,
  modalPostStock: {
    listAccept: '',
    itemsAccept: [],
    plantId: null
  },

  visibleModalShipmentCheckFIFO: false,
  loadedModalShipmentCheckFIFO: false,
  modalShipmentCheckFIFO: {
    plantId: '',
    selectItems: [],
    selectList: []
  },
  visibleModalPostStockConsignment: false,
  loadedModalPostStockConsignment: false,
  modalPostStockConsignment: {
    selectSubmergeItems: [],
    plantId: null,
    selectAcceptItems: []
  },
  visibleModalShipmentSubmerge: false,
  loadedModalShipmentSubmerge: false,
  modalShipmentSubmerge: {
    selectSubmergeItems: [],
    plantId: null,
    listSubmergeItems: [],
    itemAcceptContainer: '',
    itemAcceptLoadDate: '',
    itemAcceptPlomba: '',
    itemAcceptTtn: '',
    itemAcceptTtnDate: '',
    itemAcceptVehicle: '',
    itemAcceptActualShipmentDate: '',
    itemNextPlant: '',
    itemMH3: '',
    qcShopId: '',
    itemAcceptShippingOnBoards: '',
    itemAcceptShipmentModeRequirement: ''
  },
  visibleModalShipmentRedeemConsignment: false,
  loadedModalShipmentRedeemConsignment: false,
  modalShipmentRedeemConsignment: {
    selectSubmergeItems: [],
    plantId: null,
    listSubmergeItems: []
  },
  visibleModalShipmentPlanReady: false,
  loadedModalShipmentPlanReady: false,
  modalShipmentPlanReady: {
    plantId: null,
    items: [],
    selectItems: []
  },
  visibleModalShipmentReturn: false,
  loadedModalShipmentReturn: false,
  modalShipmentReturn: {
    plantId: null,
    selectList: [],
    isHoldOn: false
  },
  visibleModalSK: false,
  loadedModalSK: false,
  modalSK: {
    plantId: null,
    qcId: null,
    qcNumId: null,
    qcShop: null,
    qcDate: null,
    loading: false
  },

  visibleModalSKZip: false,
  loadedModalSKZip: false,
  modalSKZip: {
    data: null,
    plantId: null,
    loading: false
  },

  visibleModalProcessingStart: false,
  loadedModalProcessingStart: false,
  modalProcessingStart: {
    plantId: null,
    selectList: []
  },

  visibleModalShipmentPlan: false,
  loadedModalShipmentPlan: false,
  modalShipmentPlan: {
    plantId: null,
    selectList: []
  },

  visibleModalShipmentPlanCancel: false,
  loadedModalShipmentPlanCancel: false,
  modalShipmentPlanCancel: {
    plantId: null,
    selectList: []
  },

  visibleModalMessage: false,
  loadedModalMessage: false,
  modalMessage: {
    isEditing: false,
    modalShippingType: null,
    showAllMessages: false
  },
  visibleModalAddMessage: false,
  modalAddMessage: {
    messageShippingType: null,
    mode: null,
    userMessageNumId: null
  },
  listShippingTypes: [
    {
      id: -1,
      name: 'Все типы складов'
    },
    {
      id: 0,
      name: 'Экспедиторы'
    },
    {
      id: 1,
      name: 'Консигнаторы'
    },
    {
      id: 2,
      name: 'Переработчики'
    }
  ],
  visibleModalQRLink: false,
  loadedModalQRLink: false,

  visibleModalShipmentCancelReason: false,
  loadedModalShipmentCancelReason: false,
  modalShipmentCancelReason: {
    plantId: null,
    selectList: [],
    listNotSubmerge: '',
    selectListData: ''
  },

  visibleModalShipmentCancelReasonConsignment: false,
  modalShipmentCancelReasonConsignment: {
    plantId: null,
    listNotSubmerge: '',
    selectNotSubmergeItems: [],
    selectRejectText: ''
  },

  visibleModalDeletingPiece: false,
  loadedModalDeletingPiece: false,
  modalDeletingPiece: {
    plantId: null,
    selectList: []
  },

  visibleModalAwaitingProcessingStart: false,
  loadedModalAwaitingProcessingStart: false,
  modalAwaitingProcessingStart: {
    plantId: null,
    dateProcessing: null,
    selectList: []
  },

  visibleModalShipmentAddReportOverdue: false,
  loadedModalShipmentAddReportOverdue: false,
  modalShipmentAddReportOverdue: {
    listItems: []
  },

  visibleModalSZRebinding: false,
  loadedModalSZRebinding: false,
  modalSZRebinding: {
    plantId: null,
    selectList: [],
    filter: []
  },

  visibleModalAddComment: false,
  loadedModalAddComment: false,
  modalAddComment: {
    plantIds: []
  },

  visibleModalOnHold: false,
  loadedModalOnHold: false,
  modalOnHold: {
    plantIds: []
  },
  visibleModalSurvey: false,
  loadedModalSurvey: false,
  modalSurvey: {
    data: {}
  },

  visibleModalShipmentClientArrivalDate: false,
  loadedModalShipmentClientArrivalDate: false,
  modalShipmentClientArrivalDate: {
    plantId: null,
    pieceNumIds: [],
    qcIds: [],
    filterDataGrid: {}
  },

  visibleModalSelectFields: false,
  loadedModalSelectFields: false,
  modalSelectFields: {
    gridName: null,
    plantType: null,
    plantId: null,
    storingName: null // потом убрать
  }
};

const reducer = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case actionTypes.MODAL_SHIPMENT_CHECK_FIFO_OPEN:
      return {
        ...state,
        visibleModalShipmentCheckFIFO: true,
        loadedModalShipmentCheckFIFO: true,
        modalShipmentCheckFIFO: {
          ...state.modalShipmentCheckFIFO,
          plantId: payload.plantId,
          selectItems: payload.selectItems,
          selectList: payload.selectList
        }
      };
    case actionTypes.MODAL_SHIPMENT_CHECK_FIFO_CLOSE:
      return {
        ...state,
        visibleModalShipmentCheckFIFO: false,
        modalShipmentCheckFIFO: {
          ...state.modalShipmentCheckFIFO,
          plantId: null,
          selectItems: [],
          selectList: []
        }
      };
    case actionTypes.MODAL_SHIPMENT_CANCEL_REASON_CONSIGNMENT_OPEN:
      return {
        ...state,
        visibleModalShipmentCancelReasonConsignment: true,
        modalShipmentCancelReasonConsignment: { plantId: payload.plantId }
      };
    case actionTypes.MODAL_SHIPMENT_CANCEL_REASON_CONSIGNMENT_CLOSE:
      return {
        ...state,
        visibleModalShipmentCancelReasonConsignment: false,
        modalShipmentCancelReasonConsignment: {
          plantId: null,
          listNotSubmerge: ''
        }
      };
    case actionTypes.MODAL_SHIPMENT_CANCEL_REASON_OPEN:
      return {
        ...state,
        visibleModalShipmentCancelReason: true,
        loadedModalShipmentCancelReason: true,
        modalShipmentCancelReason: {
          plantId: payload.plantId,
          selectList: payload.selectList,
          listNotSubmerge: payload.listNotSubmerge,
          selectListData: payload.selectListData
        }
      };
    case actionTypes.MODAL_SHIPMENT_CANCEL_REASON_CLOSE:
      return {
        ...state,
        visibleModalShipmentCancelReason: false,
        modalShipmentCancelReason: {
          plantId: null,
          selectList: [],
          listNotSubmerge: '',
          selectListData: ''
        }
      };
    case actionTypes.MODAL_QR_LINK_OPEN:
      return {
        ...state,
        visibleModalQRLink: true,
        loadedModalQRLink: true,
        modalQRLink: { ...state.modalQRLink }
      };
    case actionTypes.MODAL_QR_LINK_CLOSE:
      return {
        ...state,
        visibleModalQRLink: false,
        modalQRLink: { ...state.modalQRLink }
      };
    case actionTypes.MODAL_MESSAGE_OPEN:
      return {
        ...state,
        visibleModalMessage: true,
        loadedModalMessage: true,
        modalMessage: {
          ...state.modalMessage,
          isEditing: payload && payload.isEditing,
          modalShippingType: payload && payload.modalShippingType,
          showAllMessages: payload && payload.showAllMessages
        }
      };
    case actionTypes.MODAL_MESSAGE_CLOSE:
      return {
        ...state,
        visibleModalMessage: false,
        visibleModalAddMessage: false,
        modalMessage: {
          ...state.modalMessage,
          isEditing: false
        },
        modalAddMessage: {
          messageShippingType: null,
          mode: null,
          userMessageNumId: null
        }
      };
    case actionTypes.MODAL_ADD_MESSAGE_OPEN:
      return {
        ...state,
        visibleModalMessage: false,
        visibleModalAddMessage: true,
        modalAddMessage: {
          messageShippingType: payload.messageShippingType,
          mode: payload.mode,
          userMessageNumId: payload.userMessageNumId
        }
      };
    case actionTypes.MODAL_ADD_MESSAGE_CLOSE:
      return {
        ...state,
        visibleModalMessage: true,
        visibleModalAddMessage: false,
        modalAddMessage: {
          messageShippingType: null,
          mode: null,
          userMessageNumId: null
        }
      };
    case actionTypes.MODAL_SHIPMENT_PLAN_CANCEL_OPEN:
      return {
        ...state,
        visibleModalShipmentPlanCancel: true,
        loadedModalShipmentPlanCancel: true,
        modalShipmentPlanCancel: {
          ...state.modalShipmentPlanCancel,
          plantId: payload.plantId,
          selectList: payload.selectList
        }
      };
    case actionTypes.MODAL_SHIPMENT_PLAN_CANCEL_CLOSE:
      return {
        ...state,
        visibleModalShipmentPlanCancel: false,
        modalShipmentPlanCancel: {
          ...state.modalShipmentPlanCancel,
          plantId: null,
          selectList: []
        }
      };
    case actionTypes.MODAL_SHIPMENT_PLAN_OPEN:
      return {
        ...state,
        visibleModalShipmentPlan: true,
        loadedModalShipmentPlan: true,
        modalShipmentPlan: {
          ...state.modalShipmentPlan,
          plantId: payload.plantId,
          selectList: payload.selectList
        }
      };
    case actionTypes.MODAL_SHIPMENT_PLAN_CLOSE:
      return {
        ...state,
        visibleModalShipmentPlan: false,
        modalShipmentPlan: {
          ...state.modalShipmentPlan,
          plantId: null,
          selectList: []
        }
      };
    case actionTypes.MODAL_PROCESSING_START_OPEN:
      return {
        ...state,
        visibleModalProcessingStart: true,
        loadedModalProcessingStart: true,
        modalProcessingStart: {
          ...state.modalProcessingStart,
          plantId: payload.plantId,
          selectList: payload.selectList
        }
      };
    case actionTypes.MODAL_PROCESSING_START_CLOSE:
      return {
        ...state,
        visibleModalProcessingStart: false,
        modalProcessingStart: {
          ...state.modalProcessingStart,
          plantId: null,
          selectList: []
        }
      };

    case actionTypes.MODAL_SHIPMENT_REDEEM_CONSIGNMENT_OPEN:
      return {
        ...state,
        visibleModalShipmentRedeemConsignment: true,
        loadedModalShipmentRedeemConsignment: true,
        modalShipmentRedeemConsignment: {
          ...state.modalShipmentRedeemConsignment,
          selectSubmergeItems: payload.selectSubmergeItems,
          plantId: payload.plantId,
          listSubmergeItems: payload.listSubmergeItems
        }
      };
    case actionTypes.MODAL_SHIPMENT_REDEEM_CONSIGNMENT_CLOSE:
      return {
        ...state,
        visibleModalShipmentRedeemConsignment: false,
        modalShipmentRedeemConsignment: {
          ...state.modalShipmentRedeemConsignment,
          selectSubmergeItems: [],
          plantId: null,
          listSubmergeItems: []
        }
      };
    case actionTypes.MODAL_SHIPMENT_PLAN_READY_OPEN:
      return {
        ...state,
        visibleModalShipmentPlanReady: true,
        loadedModalShipmentPlanReady: true,
        modalShipmentPlanReady: {
          ...state.modalShipmentPlanReady,
          items: payload.items,
          selectItems: payload.selectItems,
          plantId: payload.plantId
        }
      };
    case actionTypes.MODAL_SHIPMENT_PLAN_READY_CLOSE:
      return {
        ...state,
        visibleModalShipmentPlanReady: false,
        modalShipmentPlanReady: {
          ...state.modalShipmentPlanReady,
          selectItems: [],
          items: [],
          plantId: null
        }
      };
    case actionTypes.MODAL_SHIPMENT_SUBMERGE_OPEN:
      return {
        ...state,
        status: 1,
        visibleModalShipmentSubmerge: true,
        loadedModalShipmentSubmerge: true,
        modalShipmentSubmerge: {
          ...state.modalShipmentSubmerge,
          selectSubmergeItems: payload.selectSubmergeItems,
          plantId: payload.plantId,
          listSubmergeItems: payload.listSubmergeItems,
          itemAcceptContainer: payload.itemAcceptContainer,
          itemAcceptLoadDate: payload.itemAcceptLoadDate,
          itemAcceptPlomba: payload.itemAcceptPlomba,
          itemAcceptTtn: payload.itemAcceptTtn,
          itemAcceptTtnDate: payload.itemAcceptTtnDate,
          itemAcceptVehicle: payload.itemAcceptVehicle,
          itemAcceptActualShipmentDate: payload.itemAcceptActualShipmentDate,
          itemNextPlant: payload.itemAcceptNextPlant,
          itemMH3: payload.itemAcceptMh3,
          qcShopId: payload.qcShopId,
          itemAcceptShippingOnBoards: payload.itemAcceptShippingOnBoards,
          itemAcceptShipmentModeRequirement: payload.itemAcceptShipmentModeRequirement
        }
      };
    case actionTypes.MODAL_SHIPMENT_SUBMERGE_CLOSE:
      return {
        ...state,
        status: 2,
        visibleModalShipmentSubmerge: false,
        modalShipmentSubmerge: {
          ...state.modalShipmentSubmerge,
          selectSubmergeItems: [],
          listSubmergeItems: [],
          itemAcceptContainer: '',
          itemAcceptLoadDate: '',
          itemAcceptPlomba: '',
          itemAcceptTtn: '',
          itemAcceptTtnDate: '',
          itemAcceptVehicle: '',
          itemAcceptActualShipmentDate: '',
          itemNextPlant: '',
          itemMH3: '',
          itemAcceptShippingOnBoards: '',
          itemAcceptShipmentModeRequirement: ''
        }
      };

    case actionTypes.MODAL_POST_STOCK_OPEN:
      return {
        ...state,
        status: 1,
        visibleModalPostStock: true,
        loadedModalPostStock: true,
        modalPostStock: {
          ...state.modalPostStock,
          listAccept: payload.listAccept,
          plantId: payload.plantId,
          itemsAccept: payload.itemsAccept
        }
      };
    case actionTypes.MODAL_POST_STOCK_CLOSE:
      return {
        ...state,
        status: 2,
        visibleModalPostStock: false,
        modalPostStock: {
          ...state.modalPostStock,
          listAccept: '',
          itemsAccept: [],
          plantId: null
        }
      };

    case actionTypes.MODAL_POST_STOCK_CONSIGNMENT_OPEN:
      return {
        ...state,
        status: 1,
        visibleModalPostStockConsignment: true,
        loadedModalPostStockConsignment: true,
        modalPostStockConsignment: {
          ...state.modalPostStockConsignment,
          selectSubmergeItems: payload.selectSubmergeItems,
          plantId: payload.plantId,
          selectAcceptItems: payload.selectAcceptItems
        }
      };
    case actionTypes.MODAL_POST_STOCK_CONSIGNMENT_CLOSE:
      return {
        ...state,
        status: 2,
        visibleModalPostStockConsignment: false,
        modalPostStockConsignment: {
          ...state.modalPostStockConsignment,
          selectSubmergeItems: [],
          plantId: null,
          selectAcceptItems: []
        }
      };

    case actionTypes.MODAL_SHIPMENT_RETURN_OPEN:
      return {
        ...state,
        status: 1,
        visibleModalShipmentReturn: true,
        loadedModalShipmentReturn: true,
        modalShipmentReturn: {
          ...state.modalShipmentReturn,
          plantId: payload.plantId,
          selectList: payload.selectList,
          isHoldOn: payload.isHoldOn
        }
      };

    case actionTypes.MODAL_SHIPMENT_RETURN_CLOSE:
      return {
        ...state,
        status: 2,
        visibleModalShipmentReturn: false,
        modalShipmentReturn: {
          ...state.modalShipmentReturn,
          plantId: null,
          selectList: [],
          isHoldOn: false
        }
      };

    case actionTypes.MODAL_SK_OPEN:
      return {
        ...state,
        visibleModalSK: true,
        loadedModalSK: true,
        modalSK: {
          ...state.modalSK,
          plantId: payload.plantId,
          qcId: payload.qcId,
          qcNumId: payload.qcNumId,
          qcShop: payload.qcShop,
          qcDate: payload.qcDate
        }
      };
    case actionTypes.MODAL_SK_CLOSE:
      return {
        ...state,
        visibleModalSK: false,
        modalSK: {
          ...state.modalSK,
          plantId: null,
          qcId: null,
          qcNumId: null,
          qcShop: null,
          qcDate: null
        }
      };
    case actionTypes.MODAL_SK_CREATE:
      return {
        ...state,
        modalSK: {
          ...state.modalSK,
          loading: true
        }
      };
    case actionTypes.MODAL_SK_CREATE_SUCCESS:
      return {
        ...state,
        modalSK: {
          ...state.modalSK,
          loading: false
        }
      };
    case actionTypes.MODAL_SK_CREATE_FAIL:
      return {
        ...state,
        modalSK: {
          ...state.modalSK,
          loading: false
        }
      };

    case actionTypes.MODAL_SK_ZIP_OPEN:
      return {
        ...state,
        visibleModalSKZip: true,
        loadedModalSKZip: true,
        modalSKZip: {
          ...state.modalSKZip,
          data: payload.data,
          plantId: payload.plantId
        }
      };
    case actionTypes.MODAL_SK_ZIP_CLOSE:
      return {
        ...state,
        visibleModalSKZip: false,
        modalSKZip: {
          ...state.modalSKZip,
          data: null
        }
      };
    case actionTypes.MODAL_SK_ZIP_CREATE:
      return {
        ...state,
        modalSKZip: {
          ...state.modalSKZip,
          loading: true
        }
      };
    case actionTypes.MODAL_SK_ZIP_CREATE_SUCCESS:
      return {
        ...state,
        visibleModalSKZip: false,
        modalSKZip: {
          ...state.modalSKZip,
          loading: false
        }
      };
    case actionTypes.MODAL_SK_ZIP_CREATE_FAIL:
      return {
        ...state,
        modalSKZip: {
          ...state.modalSKZip,
          loading: false
        }
      };

    case actionTypes.MODAL_STATUS_CLEAR:
      return {
        ...state,
        status: 0
      };

    case actionTypes.MODAL_DELETING_PIECE_OPEN:
      return {
        ...state,
        visibleModalDeletingPiece: true,
        loadedModalDeletingPiece: true,
        modalDeletingPiece: {
          ...state.modalDeletingPiece,
          plantId: payload.plantId,
          selectList: payload.selectList
        }
      };
    case actionTypes.MODAL_DELETING_PIECE_CLOSE:
      return {
        ...state,
        visibleModalDeletingPiece: false,
        modalDeletingPiece: {
          ...state.modalDeletingPiece,
          plantId: null,
          selectList: []
        }
      };

    case actionTypes.MODAL_AWAITING_PROCESSING_START_OPEN:
      return {
        ...state,
        visibleModalAwaitingProcessingStart: true,
        loadedModalAwaitingProcessingStart: true,
        modalAwaitingProcessingStart: {
          ...state.modalAwaitingProcessingStart,
          plantId: payload.plantId,
          // dateProcessing: payload.dateProcessing,
          selectList: payload.selectList
        }
      };
    case actionTypes.MODAL_AWAITING_PROCESSING_START_CLOSE:
      return {
        ...state,
        visibleModalAwaitingProcessingStart: false,
        modalAwaitingProcessingStart: {
          ...state.modalAwaitingProcessingStart,
          plantId: null,
          dateProcessing: null,
          selectList: []
        }
      };
    case actionTypes.MODAL_SHIPMENT_ADD_REPORT_OVERDUE_OPEN:
      return {
        ...state,
        visibleModalShipmentAddReportOverdue: true,
        loadedModalShipmentAddReportOverdue: true,
        modalShipmentAddReportOverdue: {
          ...state.modalShipmentAddReportOverdue,
          listItems: payload.listItems
        }
      };
    case actionTypes.MODAL_SHIPMENT_ADD_REPORT_OVERDUE_CLOSE:
      return {
        ...state,
        visibleModalShipmentAddReportOverdue: false,
        modalShipmentAddReportOverdue: {
          ...state.modalShipmentAddReportOverdue,
          plantId: null,
          listItems: []
        }
      };
    case actionTypes.MODAL_SHIPMENT_SZ_REBINDING_OPEN:
      return {
        ...state,
        visibleModalSZRebinding: true,
        loadedModalSZRebinding: true,
        modalSZRebinding: {
          ...state.modalSZRebinding,
          plantId: payload.plantId,
          selectList: payload.selectList,
          filter: payload.filter
        }
      };
    case actionTypes.MODAL_SHIPMENT_SZ_REBINDING_CLOSE:
      return {
        ...state,
        visibleModalSZRebinding: false,
        modalSZRebinding: {
          ...state.modalSZRebinding,
          plantId: null,
          selectList: [],
          filter: []
        }
      };
    case actionTypes.MODAL_ADD_COMMENT_OPEN:
      return {
        ...state,
        visibleModalAddComment: true,
        loadedModalAddComment: true,
        modalAddComment: {
          ...state.modalAddComment,
          plantIds: payload
        }
      };
    case actionTypes.MODAL_ADD_COMMENT_CLOSE:
      return {
        ...state,
        visibleModalAddComment: false,
        modalAddComment: {
          ...state.modalAddComment,
          plantIds: []
        }
      };
    case actionTypes.MODAL_ON_HOLD_OPEN:
      return {
        ...state,
        visibleModalOnHold: true,
        loadedModalOnHold: true,
        modalOnHold: {
          ...state.modalOnHold,
          plantIds: payload
        }
      };
    case actionTypes.MODAL_ON_HOLD_CLOSE:
      return {
        ...state,
        visibleModalOnHold: false,
        modalOnHold: {
          ...state.modalOnHold,
          plantIds: []
        }
      };
    // Модальное окно опроса
    case actionTypes.MODAL_SURVEY_OPEN:
      return {
        ...state,
        visibleModalSurvey: true,
        loadedModalSurvey: true,
        modalSurvey: {
          ...state.modalSurvey,
          data: payload
        }
      };
    case actionTypes.MODAL_SURVEY_CLOSE:
      return {
        ...state,
        visibleModalSurvey: false,
        modalSurvey: {
          data: {}
        }
      };
    case actionTypes.MODAL_SHIPMENT_CLIENT_ARRIVAL_DATE_OPEN:
      return {
        ...state,
        visibleModalShipmentClientArrivalDate: true,
        loadedModalShipmentClientArrivalDate: true,
        modalShipmentClientArrivalDate: {
          ...state.modalShipmentClientArrivalDate,
          plantId: payload.plantId,
          pieceNumIds: payload.pieceNumIds,
          qcIds: payload.qcIds,
          filterDataGrid: payload.filterDataGrid
        }
      };
    case actionTypes.MODAL_SHIPMENT_CLIENT_ARRIVAL_DATE_CLOSE:
      return {
        ...state,
        visibleModalShipmentClientArrivalDate: false,
        modalShipmentClientArrivalDate: {
          pieceNumIds: [],
          qcIds: [],
          plantId: null,
          filterDataGrid: {}
        }
      };
    case actionTypes.MODAL_SELECT_FIELDS_OPEN:
      return {
        ...state,
        visibleModalSelectFields: true,
        loadedModalSelectFields: true,
        modalSelectFields: {
          ...state.modalSelectFields,
          gridName: payload.gridName,
          plantType: payload.plantType,
          plantId: payload.plantId,
          storingName: payload.storingName // потом убрать
        }
      };
    case actionTypes.MODAL_SELECT_FIELDS_CLOSE:
      return {
        ...state,
        visibleModalSelectFields: false,
        modalSelectFields: {
          ...initialState.modalSelectFields
        }
      };

    default:
      return state;
  }
};

export default reducer;
